{
  "Several people are typing...": "Several people are typing...",
  "{{name}} is typing..._one": "{{name}} is typing...",
  "{{name}} is typing..._other": "{{name}} are typing..."
}
